import React from "react";
import { apiClient } from "../../../shared/utils/apiClient";

interface PracticeFavoriteButtonProps {
  favorited: boolean;
  authenticity_token: string;
  path: string;
}

interface FavoriteState {
  favorited: boolean;
}

function PracticeFavoriteButton(props: PracticeFavoriteButtonProps) {
  const [state, setState] = React.useState<FavoriteState>({
    favorited: props.favorited,
  });

  const toggleFavorite = async () => {
    try {
      const response = await apiClient.post<{ status?: { favorited?: boolean } }>(
        props.path,
        {},
        {
          headers: {
            "X-CSRF-Token": props.authenticity_token,
          },
        }
      );

      if (!response.ok || !response.data?.status) return;

      const { favorited } = response.data.status;
      setState({ ...state, favorited: !!favorited });
    } catch (error) {
      console.log(error);
    }
  };

  const favoriteCaption = () => {
    return state.favorited ? "Unfavorite" : "Favorite";
  };

  return (
    <button
      className={`job-btn ${state.favorited ? 'job-btn--success' : 'job-btn--outline'}`}
      onClick={toggleFavorite}
    >
      <i className="fa fa-heart"></i>
      {' '}{favoriteCaption()}
    </button>
  );
}

export default PracticeFavoriteButton;
